import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: ${props => props.background ? props.background : 'transparent'};
`;
